import { render, staticRenderFns } from "./vehicle-search-details-skeleton-loader.vue?vue&type=template&id=0d5722eb&scoped=true&"
import script from "./vehicle-search-details-skeleton-loader.vue?vue&type=script&lang=js&"
export * from "./vehicle-search-details-skeleton-loader.vue?vue&type=script&lang=js&"
import style0 from "./vehicle-search-details-skeleton-loader.vue?vue&type=style&index=0&id=0d5722eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5722eb",
  null
  
)

export default component.exports